import React from 'react';
import { useLocation } from 'react-router';
import { Receipt } from 'lucide-react';
import { useLanguage } from '../lang/LangContext';
import { KEYS } from '../lang/index';
import LanguagePicker from './LanguagePicker';

const getRouteTitles = (t) => ({
  '/': t(KEYS.NAV_DASHBOARD),
  '/suppliers': t(KEYS.NAV_SUPPLIERS),
  '/services': t(KEYS.NAV_SERVICES),
  '/invoices': t(KEYS.NAV_INVOICES),
  '/profile': t(KEYS.NAV_PROFILE),
  '/reminders': t(KEYS.NAV_REMINDERS),
  '/notifications': t(KEYS.NAV_NOTIFICATIONS),
  '/api-keys': t(KEYS.NAV_API_KEYS),
});

const TopBar = () => {
  const location = useLocation();
  const { t } = useLanguage();

  const pageTitle = getRouteTitles(t)[location.pathname] || '';

  const today = new Date().toLocaleDateString('en-US', {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
  });

  return (
    <header className="fixed top-0 left-0 right-0 z-40 h-14 flex items-center justify-between px-5 bg-surface-raised border-b border-surface-border">
      {/* Left — Logo */}
      <div className="flex items-center gap-3">
        <div className="flex items-center gap-2">
          <Receipt className="w-4.5 h-4.5 text-accent" />
          <span className="text-sm font-bold text-text-primary tracking-tight">
            Bills<span className="text-accent">ops</span>
          </span>
        </div>
        {pageTitle && (
          <>
            <span className="text-surface-border">/</span>
            <span className="text-sm font-medium text-text-secondary">{pageTitle}</span>
          </>
        )}
      </div>
      
      {/* Right — Language picker + Date */}
      <div className="flex items-center gap-3">
        <LanguagePicker />
        <span className="text-xs font-mono text-text-muted hidden sm:inline">
          {today}
        </span>
      </div>
    </header>
  );
};

export default TopBar;
